import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { UsersComponent } from './admins/users/users.component';
import { ColaboratorsComponent } from './colaborators/colaborators.component';
import { AdminsComponent } from './admins/admins.component';
import { SettingsComponent } from './settings/settings.component';

import { RoleComponent } from './admins/role/role.component';
import { ClientsComponent } from './admins/clients/clients.component';
import { RepohomeComponent } from './reports/repohome/repohome.component';
import { SalesHomeComponent } from './sales/sales-home/sales-home.component';
import { InfoFilesComponent } from './sales/info-files/info-files.component';
import { AgentsComponent } from './sales/agents/agents.component';
import { AgentBackupComponent } from './sales/agent-backup/agent-backup.component';
import { SysparamsComponent } from './admins/sysparams/sysparams.component';
import { AgentManagementReportComponent } from './sales/agent-management-report/agent-management-report.component';
import { OrderFollowupReportComponent } from './sales/order-followup-report/order-followup-report.component';
import { CurrentVersionReportComponent } from './sales/current-version-report/current-version-report.component';
import { SyncAuditReportComponent } from './sales/sync-audit-report/sync-audit-report.component';
import { OrderApproversComponent } from './sales/order-approvers/order-approvers.component';
import { SubjectsComponent } from './sales/subjects/subjects.component';
import { GradesComponent } from './sales/grades/grades.component';
import { MaterialgroupComponent } from './sales/discounts/materialgroup/materialgroup.component';
import { BrandComponent } from './sales/discounts/brand/brand.component';
import { GroupbrandComponent } from './sales/discounts/groupbrand/groupbrand.component';

import { LoginService } from '../services/authentication/login.service';

export const Hivimarroutes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [LoginService],
    children: [
      //{ path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '', redirectTo: 'admins', pathMatch: 'full' },
      {
        path: 'home',
        component: ColaboratorsComponent,
        canActivate: [LoginService],
        data: {
          title: 'Módulos',
          urls: [
            /*{ title: 'Mapas', url: '' },
            { title: 'Mapas' }*/
          ]
        }
      },
      {
        path: 'admins',
        component: AdminsComponent,
        canActivate: [LoginService],
        data: {
          title: 'General Settings',
          urls: [
            /*{ title: 'Mapas', url: '' },
            { title: 'Mapas' }*/
          ]
        }
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [LoginService],
        data: {
          title: 'Configuraciones',
          urls: []
        }
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [LoginService],
        data: {
          title: 'Usuarios',
          urls: [
            { title: 'General Settings', url: '/admins' },
            { title: 'Usuarios'}
          ]
        }
      },
      {
        path: 'roles',
        component: RoleComponent,
        canActivate: [LoginService],
        data: {
          title: 'Perfiles de usuario',
          urls: [
            { title: 'General Settings', url: '/admins' },
            { title: 'Perfiles de usuario'}
          ]
        }
      },
      {
        path: 'sysparams',
        component: SysparamsComponent,
        canActivate: [LoginService],
        data: {
          title: 'Parámetros de Sistema',
          urls: [
            { title: 'General Settings', url: '/admins' },
            { title: 'Parámetros de Sistema'}
          ]
        }
      },
      {
        path: 'sales',
        component: SalesHomeComponent,
        canActivate: [LoginService],
        data: {
          title: 'Ventas',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas'}
          ]
        }
      },
      {
        path: 'sales-info-files',
        component: InfoFilesComponent,
        canActivate: [LoginService],
        data: {
          title: 'Info Archivos',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Info Archivos'}
          ]
        }
      },
      {
        path: 'sales-agents',
        component: AgentsComponent,
        canActivate: [LoginService],
        data: {
          title: 'Agentes',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Agentes'}
          ]
        }
      },
      {
        path: 'sales-agent-backup',
        component: AgentBackupComponent,
        canActivate: [LoginService],
        data: {
          title: 'Agente Backup',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Agente Backup'}
          ]
        }
      },
      {
        path: 'agent-management-report',
        component: AgentManagementReportComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Gestión de Agentes',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Gestión de Agentes'}
          ]
        }
      },
      {
        path: 'order-followup-report',
        component: OrderFollowupReportComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Seguimiento de Pedidos',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Seguimiento de Pedidos'}
          ]
        }
      },
      {
        path: 'version-report',
        component: CurrentVersionReportComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Reporte de Versiones',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Reporte de Versiones'}
          ]
        }
      },
      {
        path: 'sync-audit-report',
        component: SyncAuditReportComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Auditoria de Sincronizaciones',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Auditoria de Sincronizaciones'}
          ]
        }
      },
      {
        path: 'order-approvers',
        component: OrderApproversComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Aprobadores de Pedidos',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Aprobadores de Pedidos'}
          ]
        }
      },
      {
        path: 'sales-subjects',
        component: SubjectsComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Materias',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Materias'}
          ]
        }
      },
      {
        path: 'sales-grades',
        component: GradesComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Notas Vendedores',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Notas Vendedores'}
          ]
        }
      },
      {
        path: 'sales-discounts-materialgroup',
        component: MaterialgroupComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Grupo de Materiales para margen de ganancia',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Grupo de Materiales para margen de ganancia'}
          ]
        }
      },
      {
        path: 'sales-discounts-brand',
        component: BrandComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Marcas para margen de ganancia',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Marcas para margen de ganancia'}
          ]
        }
      },
      {
        path: 'sales-discounts-groupbrand',
        component: GroupbrandComponent,
        //canActivate: [LoginService],
        data: {
          title: 'Grupos y Marcas para margen de ganancia',
          urls: [
            { title: 'Módulos', url: '/home' },
            { title: 'Ventas', url: '/sales' },
            { title: 'Grupos y Marcas para margen de ganancia'}
          ]
        }
      },
      {
        path: 'clients',
        component: ClientsComponent,
        canActivate: [LoginService],
        data: {
          title: 'Clientes',
          urls: [
            { title: 'General Settings', url: '/admins' },
            { title: 'Clientes'}
          ]
        }
      },
      //end
    ]
  },
];
